import ReactPixel from "react-facebook-pixel";

export function initializeFacebookPixel() {
    const options = {
        autoConfig: true, 	// set pixel's autoConfig
        debug: false, 		// enable logs
    };
    ReactPixel.init("353302375099423", null, options);
}

export function pageView() {
    ReactPixel.pageView();
}
export function logCustomEvent(event, data) {
    ReactPixel.trackCustom(event, data);
}
